// extracted by mini-css-extract-plugin
export default {"element":"NoDiploma_element__ikq-o","info":"NoDiploma_info__NXtR+"};